import { BaseEnum } from "../BaseEnum";

export class DsrDataProcessingStatus extends BaseEnum {
  static NOT_REQUIRED = 0;
  static PENDING = 1;
  static PROCESSING = 2;
  static READY = 3;
  static COMPLETED = 4;
  static FAILED = 5;

  static Codes = [
    this.NOT_REQUIRED,
    this.PENDING,
    this.PROCESSING,
    this.READY,
    this.COMPLETED,
    this.FAILED,
  ];

  static _labelKeys = [
    "enums.dsr-data-processing-status.NOT_REQUIRED",
    "enums.dsr-data-processing-status.PENDING",
    "enums.dsr-data-processing-status.PROCESSING",
    "enums.dsr-data-processing-status.READY",
    "enums.dsr-data-processing-status.COMPLETED",
    "enums.dsr-data-processing-status.FAILED",
  ];

  static isBlocked(status) {
    return [this.PENDING, this.PROCESSING, this.FAILED].includes(status);
  }
}
